/* eslint-disable quote-props */
/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

const brokingSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "What is a demat account and how does it work?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "A demat account is like a digital vault for your financial securities. It holds stocks, bonds, and mutual funds in a dematerialised form. You can use Wealthy’s demat account to invest and trade in stocks, bonds and ETFs"
    }
  }, {
    "@type": "Question",
    "name": "What types of securities can be held in a demat account?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "There are a number of securities which you can hold in demat form in India such as equity shares of listed and unlisted companies, government bonds, corporate bonds, ETF units, and mutual fund units that are held in demat form."
    }
  }, {
    "@type": "Question",
    "name": "What are the charges for opening and maintaining a demat and trading account with Wealthy?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Wealthy demat account doesn’t have any account opening and annual maintenance charges. Instead, you'll only pay a small commission on each of your trades - either a flat rate of Rs. 20 or 0.05% of the order amount, whichever is lower. Moreover, for investors, we have an even sweeter offer, as delivery trade on Wealthy platform is free of cost."
    }
  }, {
    "@type": "Question",
    "name": "What are the benefits of having a demat and trading account with Wealthy?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Wealthy has the lowest brokerage charges and does not impose any account maintenance fees on its users. With Wealthy Broking you get exclusive access to curated stock baskets called Wealthy Ideas created by our team experts. The research tools and in-depth insights will help your investment experience incredible with Wealthy."
    }
  }]
}
;

export default brokingSchema;
